"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getSymbols_1 = __importDefault(require("./getSymbols"));
const keys_1 = __importDefault(require("../keys"));
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
    const result = (0, keys_1.default)(object);
    if (!Array.isArray(object)) {
        result.push(...(0, getSymbols_1.default)(object));
    }
    return result;
}
exports.default = getAllKeys;
